import { startTransition } from "react";

type NavigateOptions = {
  replace?: boolean;
};

export default function navigate(url: string, options: NavigateOptions = {}) {
  startTransition(() => {
    console.log("START TRANSITION");
    if (options.replace) {
      history.replaceState(null, "", url);
    } else {
      history.pushState(null, "", url);
    }
  });
}
